import * as types from '../../action-types';
import {getAccount as initialState } from "../../initialState";

const getAccount = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_ACCOUNT_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_ACCOUNT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_ACCOUNT_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_ACCOUNT_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getAccount;
